import { Component, OnInit, ViewEncapsulation, EventEmitter, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { MatDialog } from '@angular/material/dialog';
import { Subject, merge } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';
import { FiltersComponent } from '../../filters/filters.component';
import { AuthenticationService } from 'app/services';
import { MeetingCreateModalComponent } from 'app/main/activities/meetings/meeting-create-modal/meeting-create-modal.component';
import { TasksCreateModalComponent } from 'app/main/activities/tasks/tasks-create-modal/tasks-create-modal.component';
import { ViewingToursModalComponent } from 'app/main/activities/viewingTours/viewing-tours-modal/viewing-tours-modal.component';
import { isEmpty, ceil, unionBy } from 'lodash';
import { BaseService } from 'app/_helpers/base/base.service';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-wg-my-schedule',
  templateUrl: './wg-my-schedule.component.html',
  styleUrls: ['./wg-my-schedule.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgMyScheduleComponent implements OnInit, AfterViewChecked, OnDestroy {

  user: any;
  addEditDialogRef: any;
  searchDialogRef: any;
  accountsDataPage: UntypedFormControl = new UntypedFormControl(1);
  scheduleType: any;
  scheduleDataRange: any;
  loadingScheduleData: boolean;
  scheduleFilter = {} as any;
  mySchedule: EventEmitter<any>;
  scheduleData = [] as any;
  @ViewChild('accountsWidget', { static: false }) private accountsWidget: ElementRef;
  accountsWidgetChecked: boolean;
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _authenticationService: AuthenticationService,
    private _gService: BaseService,
    private cdRef: ChangeDetectorRef,
    private _matDialog: MatDialog
  ) {
    this.accountsWidgetChecked = false;
    this.user = this._authenticationService.currentUserValue;
    this.mySchedule = new EventEmitter();
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.scheduleType = 'all';
    this.scheduleDataRange = 'this_week';
    this.scheduleFilter.users = [this.user._id];
    merge(this.accountsDataPage.valueChanges, this.mySchedule)
      .pipe(
        startWith(''),
        tap(() => this.loadingScheduleData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((change: string | number) => {
          if (typeof change === 'string') {
            this.accountsDataPage.setValue(1, { emitEvent: false });
            if (this.accountsWidget) {
              this.accountsWidget.nativeElement.scrollTop = 0;
            }
          }
          return this._gService.post(`dashboard/activities_schedule?range=${this.scheduleDataRange}&type=${this.scheduleType}&page=${this.accountsDataPage.value}`, this.scheduleFilter, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        if (!this.scheduleData.docs || this.accountsDataPage.value === 1) {       
          this.scheduleData = data;
        } else {
          this.scheduleData.docs = unionBy(this.scheduleData.docs, data.docs);
        }
        this.loadingScheduleData = false;
      }, () => this.loadingScheduleData = false);

  }

  addActivities(event: any, id?: string): void {
    if (event.type === 'meeting') {
      this.searchDialogRef = this._matDialog.open(MeetingCreateModalComponent, {
        panelClass: 'event-form-dialog',
        data: event
      });
    } else if (event.type === 'task') {
      this.searchDialogRef = this._matDialog.open(TasksCreateModalComponent, {
        panelClass: 'event-form-dialog',
        data: event
      });
    } else if (event.type === 'viewing') {
      this.searchDialogRef = this._matDialog.open(ViewingToursModalComponent, {
        panelClass: 'event-form-dialog',
        data: {
          relatedTo: 'update',
          _id: id
        }
      });
    }
    this.searchDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.mySchedule.next(true);
      }
    });
  }

  openFilterModal(): void {
    this.addEditDialogRef = this._matDialog.open(FiltersComponent, {
      panelClass: 'event-form-dialog',
      // data: data ? data : {},
    });
    this.addEditDialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        if (response) {
          if (response?.status) {
            this.scheduleFilter.status = response.status;
          } else {
            delete this.scheduleFilter.status;
          }
          if (response?.users && !isEmpty(response.users)) {
            this.scheduleFilter.users = response.users;
          } else {
            delete this.scheduleFilter.users;
            this.scheduleFilter.users = [this.user._id];
          }

          this.scheduleType = response.scheduleType;
          this.scheduleDataRange = response.scheduleDataRange;
          this.mySchedule.next(true);

        }
      });
  }

  ngAfterViewChecked(): void {
    if (!this.accountsWidgetChecked && this.accountsWidget) {
      this.accountsWidget.nativeElement
        .addEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.scheduleData), true);
      this.accountsWidgetChecked = true;
    }
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.accountsWidget && this.accountsWidget.nativeElement) {
      this.accountsWidget.nativeElement
        .removeEventListener('scroll', (event: any) => this.widgetScroll(event, this.accountsDataPage, this.scheduleData), true);
    }
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  widgetScroll(event: any, dataPage: UntypedFormControl, data: any): void {
    if (event.target.scrollTop + event.target.clientHeight <= event.target.scrollHeight && dataPage.value < ceil(data.total / data.limit)) {
      dataPage.setValue(dataPage.value + 1);
    }
  }

}
